import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteShipmentItem, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* deleteShipmentItemSaga(action: DeleteShipmentItem) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeDelete, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(logisticsActionCreators.removeItems([action.payload.shipmentItemId]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteShipmentItem() {
  yield takeEvery(LogisticsActionKeys.DELETE_SHIPMENT_ITEM, deleteShipmentItemSaga);
}

export async function executeDelete({
  shipmentId,
  shipmentItemId
}: {
  shipmentId: number;
  shipmentItemId: number;
}): Promise<IApiExecuteRespone> {
  return executeApiRequest(() => httpService.delete(`${ApiUrls.shipment(shipmentId)}/Items/${shipmentItemId}`), false);
}
